<template>
  <div class="sidebar">
    <div
      class="sidebar__logo-wrapper"
      @click="$router.push('/')"
    >
      <img
        :src="logo"
        alt="logo"
        class="sidebar__logo"
      >
    </div>

    <div class="nav">
      <AppSidebarButton
        v-for="(item, index) of nav"
        :key="index"
        :to="item.to"
        :icon="item.icon"
        :text="item.text"
        :active="active === item.to"
        :postscript="item.postscript"
        class="nav__item"
      />
    </div>

    <a :href="profileLink" class="sidebar__profile-wrapper">
      <UserInfo
        :userPhoto="userPhoto"
        :username="username"
        :desc="userPost"
      />
    </a>
  </div>
</template>

<script>
import AppSidebarButton from '@/components/AppSidebarButton'
import UserInfo from '@/components/UserInfo'

export default {
  name: 'AppSidebar',
  components: {
    UserInfo,
    AppSidebarButton
  },
  props: {
    logo: {
      type: String,
      default: ''
    },
    profileLink: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    userPost: {
      type: String,
      default: ''
    },
    userPhoto: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    nav: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    }
  },
  created () {
    console.log()
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  padding: 30px;
  background: #1D1D1D;
  display: flex;
  flex-direction: column;

  &__logo {
    display: block;
    width: 100%;
  }
  &__logo-wrapper {
    width: 130px;
    cursor: pointer;
  }

  &__profile-wrapper {
    display:block;
    margin-top: auto;
    color: inherit;
    text-decoration:none;
  }

  .nav {
    margin-top: 104px;

    &__item {
      &:not(:last-child) {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
